import axios from 'axios';
import {
    ListEntryApiGetResponse,
    ListEntryBulkObject,
    ListEntryFilterResponseObj,
    PatchListEntryPayload,
    PostListEntry
} from '@brighterion/types/listEntry';

let url = '';

export const initListEntryService = (config: Record<string, any>) => {
    url = config.rulesUrl;
};

export const postListBulkEntries = (listId: number) => async (data: ListEntryBulkObject) => {
    const res = await axios.post(`${url}/list/${listId}/bulk-entry-upload`, data);
    return res.data;
};

export const deleteListEntry = async (listEntryId: number, listId: number, data: RangeList) => {
    return axios.delete(`${url}/list/${listId}/entry/${listEntryId}`, { data });
};

export const postListEntry = async (id: number, data: PostListEntry) => {
    const res = await axios.post(`${url}/list/${id}/entry`, { ...data });
    return res.data;
};

export const patchListEntry = async (id: number, entryId: number, payload: PatchListEntryPayload) => {
    const res = await axios.patch(`${url}/list/${id}/entry/${entryId}`, payload);
    return res.data;
};

export const getListEntriesByList = async (listId: number) => {
    const res = await axios.get<ListEntryApiGetResponse>(`${url}/list/${listId}/entries`);
    return res.data;
};

export const getListEntriesByFilterParam = async (
    listId: number,
    exact: boolean,
    filterParam: string,
    pageParam: number,
    statusParam: string
) => {
    const res = await axios.get<ListEntryFilterResponseObj>(`${url}/list/${listId}/entry/filter`, {
        params: {
            exact,
            filterParam,
            perPage: 30,
            order: 'desc',
            page: pageParam,
            status: statusParam
        }
    });
    return res.data;
};
